module.exports = __webpack_public_path__ + "img/tether-usdt.839a0f0d.png";